var module = angular.module('octopusApp.environments');

module.controller('MachineConnectionController', function ($scope, machineState, $location, busy, octopusRepository, pollLoop) {
    $scope.machineId = machineState.machineId;
    $scope.checkHealth = checkHealth;
    $scope.upgradeTentacle = upgradeTentacle;
    $scope.isLoading = busy.create();
    $scope.isSaving = busy.create();
    $scope.lockVersion = lockVersion;
    $scope.tentacleDetails = null;

    function lockVersion(isToBeLocked) {
        $scope.machine.Endpoint.TentacleVersionDetails.UpgradeLocked = isToBeLocked;
        $scope.isSaving.promise(octopusRepository.Machines.save($scope.machine).then(function (saved) {
            $scope.machine = saved;
            $scope.tentacleDetails = $scope.machine.Endpoint.TentacleVersionDetails;
        }));
    }

    function upgradeTentacle() {
        if (!$scope.tentacleDetails) {
            return;
        }

        var task = {
            Name: 'Upgrade',
            Description: 'Upgrade ' + $scope.machine.Name + ' Tentacle',
            Arguments: {
                MachineIds: [$scope.machineId]
            }
        };
        $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
            $location.path("/tasks/" + result.Id);
        }));
    }

    function checkHealth() {
        var task = {
            Name: 'Health',
            Description: 'Check ' + $scope.machine.Name + ' health',
            Arguments: {
                Timeout: '00:05:00',
                MachineIds: [$scope.machineId]
            }
        };
        $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
            $location.path("/tasks/" + result.Id);
        }));
    }

    function refresh() {
        return $scope.isLoading.promise(machineState.load().then(function (machine) {
            $scope.machine = machine;
            $scope.tentacleDetails = $scope.machine.Endpoint.TentacleVersionDetails;

            return octopusRepository.Machines.getConnectionStatus(machine).then(function (status) {
                $scope.status = status;

                if (status.LastConnectionError) {
                    $scope.lastFailureEvent = {
                        Category: 'Error',
                        OccurredAt: status.LastFailedConnectionAttempt,
                        Detail: status.LastConnectionError,
                        MessageText: null
                    };
                } else {
                    $scope.lastFailureEvent = null;
                }
            });
        }));
    }
    pollLoop.create($scope, refresh).startImmediately();
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machines/machine_connection.js
// module id = 438
// module chunks = 1